import React, { useEffect, useState } from 'react'
import ToolsComponent from '../../components/BugBounty/ToolsComponent'
import axios from 'axios'
import ENDPOINT from '../../data/ENDPOINT';
import SecurityHeaders from '../../data/SecurityHeaders';
import divider from "../../assets/bg/divider.png";
const AllHackingTools = () => {
  const [hackingTools, setHackingTools] = useState([]);


  useEffect(()=>{
window.scrollTo(0,0)
  },[])
  const getAllHackingTools = async () => {

    try {
      const response = await axios.get(ENDPOINT + 'get-hacking-tools.php', SecurityHeaders);
      if (response) {
        if (response.data.status === "success") {
          setHackingTools(response.data.data);
        }
      } else {

        console.error('Failed to fetch hacking tools');
      }
    }
    catch (error) {
      console.error('Error fetching hacking tools:', error);
    }


  }
  useEffect(() => {
    getAllHackingTools();
  }, []);
  console.log(hackingTools);


  return (

    <>
      <div className="container mb-3 ">
<div className='mb-4'>
<h1 className='text-primary mt-4  text-center'>600+ Hacking Tools</h1>


<div className="text-center col-md-8 col-lg-8 col-12 mx-auto">
    <p className="lead">Learn Tools for every hacking operation</p>
  </div>
  <div className="divider">
  <img src={divider} alt="divider" />
</div>
</div>



          <ToolsComponent />



        
      </div>
    </>



  )
}

export default AllHackingTools
